module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/big/4-fb28143751d906c0dd25bbdb883b1004.webp";